import { createContext } from "react";

/**
 * The DOM node AppShell renders for secondary footer actions: `undefined`
 * outside an AppShell, `null` before the node mounts.
 *
 * BUNDLE SHAPE: this module is shared by the entry chunk (AppShell) and a lazy
 * route (Login, through AppFooterSecondary), so it must import nothing but
 * `react`. When Login imported AppFooterSecondary from AppShell itself, the
 * shared module also reached `react-dom` and the i18n modules, and Rolldown's
 * chunk optimizer could no longer fold React into the entry: it split React
 * into a second script that `/` and the 404 page then had to download
 * (tests/e2e/route-loading.spec.js). Keep the portal, and anything heavier
 * than React, out of here. See docs/architecture/repo-structure.md.
 */
export const FooterTarget = createContext<HTMLDivElement | null | undefined>(undefined);
